import React from 'react';
import ArticleTexts from "../components/common/ArticleTexts";
import {disclaimerContent} from "../models";

const DisclaimerPage = () => {
    return <ArticleTexts content={disclaimerContent}/>;
};

export default DisclaimerPage;
